<div class="mobile_version-backbutton">
    <a class="mobile-header" onclick="history.back()">
        <span> <img src="../../../assets/images/tournament/backBtn.svg" alt=""> </span>Wallet </a>
</div>

<section class="Wallet-secrion">
    <div class="container">
        <div class="row">
            <div class="col-md-12 wallet-div">
                <div class="mobile-version mainTitleDiv">
                    <h6>Available Balance</h6>
                </div>
                <div class="wallet-heading">
                    <h1>
                        Wallet
                    </h1>
                </div>
                <div class="main-wallet-div">
                    <div class="balance-list">
                        <ul>
                            <li>
                                <div class="walletIcons-div">
                                    <div class="icon">
                                        <img src="../../../assets/images/wallet/cashIcon.svg" alt="">
                                    </div>
                                    <div class="title">
                                        <h6>
                                            Cash
                                        </h6>
                                        <h5 class="mobile-version amountText"><i class='bx bx-rupee'></i>
                                             {{totalAvailableCash | number:'1.0-0'}}</h5>
                                    </div>
                                    <div class="amount">
                                        <h4><i class='bx bx-rupee'></i> {{totalAvailableCash | number:'1.0-0'}}</h4>
                                    </div>
                                </div>
                            </li>
                            <li>
                                <div class="walletIcons-div">
                                    <div class="icon">
                                        <img src="../../../assets/images/wallet/coinIcon.svg" alt="">
                                    </div>
                                    <div class="title">
                                        <h6>
                                            TPL Coins
                                            
                                        </h6>
                                    </div>
                                    <div class="amount">
                                        <h4>{{totalAvailableCoins | numberFormatter}}</h4>
                                    </div>
                                </div>
                            </li>

                        </ul>
                        <!--       <div class="tpls-cash-and-coins">
                        <div class="title">
                            <h4>Cash</h4>
                            <h6><span class="rupee-icon"><i class='bx bx-rupee'></i></span>{{totalAvailableCash | numberFormatter}}</h6>
                        </div>
                        <div class="add-button">
                            <button (click)="addCashOrMoney('Add Cash')">Add More Cash <span><i class='bx bx-plus'></i></span></button>
                        </div>
                    </div>
                    
                    
                    <div class="tpls-cash-and-coins">
                        <div class="title">
                            <h4>Contest Cash</h4>
                            <h6><span class="rupee-icon"><i class='bx bx-rupee'></i></span>{{totalAvailableContestCash | numberFormatter}}</h6>
                        </div>
                        <div class="add-button">
                            <button (click)="addCashOrMoney('Add Contest Cash')">Add More Contest Cash <span><i class='bx bx-plus'></i></span></button>
                        </div>
                    </div>
                 
                    <div class="pipe"></div>
                    <div class="tpls-cash-and-coins">
                        <div class="title">
                            <h4>Coins</h4>
                            <h6>{{totalAvailableCoins | numberFormatter}}</h6>
                        </div>
                        <div class="add-button">
                            <button (click)="addCoin()">Use Coins <span><i class='bx bx-plus'></i></span></button>
                        </div>
                    </div> -->


                        <div class="walletFooter">
                            <!-- <button (click)="onDownloadClick('bottom')">
                                <div class="icon">
                                    <img src="../../../assets/images/wallet/money-add.svg" alt="">
                                </div>
                                <span>WITHDRAW CASH</span>
                            </button> -->
                            <!-- <button class="addCashbtn" (click)="addCashOrMoney('Add Cash')"> -->
                            <button class="addCashbtn" (click)="onDownloadClick('bottom')">
                                <div class="icon">
                                    <img src="../../../assets/images/wallet/money-add.svg" alt="">
                                </div>
                                <span>ADD CASH</span>
                            </button>
                        </div>
                    </div>
                </div>
                <div class="mobile-verison iconCoinButton">
                    <div class="mobile-verison walletIcons-div">
                        <div class="icon">
                            <img src="../../../assets/images/wallet/coinIcon.svg" alt="">
                        </div>
                        <div class="title">
                            <h6>
                                TPL Coins
                            </h6>
                            <h4>{{totalAvailableCoins | numberFormatter}}</h4>
                        </div>
                    </div>
                </div>

                <!-- <div class="col-md-12 redemption">
                    <button class="redeem" *ngIf="userAge>17" (click)="transferAmountToBank(this.userId)">
                        Transfer Amount to Bank <i class='bx bx-up-arrow-alt'></i>
                    </button>
                    <button style="background-color: #2D2D2D !important;" class="convert" *ngIf="userAge>17" (click)="convertContestCashToCash(this.userId)">
                       <span>Convert Contest Cash to Cash</span> <span class="icon-span"><img src="../../../assets/img/convert-icon.svg" alt=""></span>
                    </button>
                </div> -->
                <div class="transation-historyTable">
                    <h3>Transaction History</h3>
                </div>
                <div class="col-md-12 text-center walletCashType">
                    <div class="searchFilter">
                        <div class="searchBardiv">
                            <div class="search">
                                <input type="text" placeholder="Search Transaction"
                                    (input)="onSearchWalletActivity($event.target.value)" />
                                <div class="icon">
                                    <img src="../../../assets/images/wallet/Magnifying.svg" alt="">
                                </div>
                            </div>
                        </div>

                        <div class="filterBtn">
                            <ul>
                                <li>
                                    <button (click)="onDownloadClick('bottom')">
                                        <div class="icon">
                                            <img src="../../../assets/images/wallet/Sort.svg " alt="">
                                        </div>
                                        <div class="title">
                                            SORT
                                        </div>
                                    </button>
                                </li>
                                <li>
                                    <button (click)="onDownloadClick('bottom')">
                                        <div class="icon">
                                            <img src="../../../assets/images/wallet/Filter.svg " alt="">
                                        </div>
                                        <div class="title">
                                            FILTER
                                        </div>
                                    </button>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <ul class="tabMenues">
                        <li *ngFor="let walletCashType of walletCashTypeArray">
                            <button pButton pRipple [label]="walletCashType?.name"
                                (click)="walletCashTypeFilterSelected(walletCashType)" class="p-button-rounded mx-2"
                                [ngClass]="(walletCashType?.name === walletCashTypeFilterOption?.name) ? 'walletCashTypeSelected' : 'walletCashTypeDeSelected'">
                            </button>
                        </li>
                    </ul>

                </div>

                <div class=" col-md-12 transation-history">
                    <div class="tableheader-heading mobile-heading">
                        <h2> Wallet History </h2>
                    </div>
                    <ul class=" mobile-verison tabMenues">
                        <li *ngFor="let walletCashType of walletCashTypeArray">
                            <button pButton pRipple [label]="walletCashType?.name"
                                (click)="walletCashTypeFilterSelected(walletCashType)" class="p-button-rounded mx-2"
                                [ngClass]="(walletCashType?.name === walletCashTypeFilterOption?.name) ? 'walletCashTypeSelected' : 'walletCashTypeDeSelected'">
                            </button>
                        </li>
                    </ul>
                    <div class="table-div w-100">
                        <p-table #dt [value]="walletlist" [rows]="10" [lazy]="true" [paginator]="true" pageLinks="3"
                            [showPageLinks]="true" paginatorDropdownAppendTo="body" [autoLayout]="true"
                            (onLazyLoad)="loadWalletHistory($event)" [totalRecords]="totalRecords"
                            [first]="(pageNumberFirst - 1) * pageLimitFirst" [loading]="loading"
                            [rowsPerPageOptions]="paginationOption">
                            <ng-template pTemplate="header">
                                <tr>
                                    <th style="display: table-cell!important;" pSortableColumn="id"
                                        class="transactionId">Transaction ID</th>
                                    <th style="display: table-cell!important;" pSortableColumn="description"
                                        class="transactiodescription">Description</th>
                                    <th style="display: table-cell!important;" pSortableColumn="created_at"
                                        class="date">Date</th>
                                    <th style="display: table-cell!important;" pSortableColumn="email"
                                        *ngIf="walletCashTypeFilterOption?.name !== 'TPL Coins'" class="amount-div">TDS
                                    </th>
                                    <th style="display: table-cell!important;" pSortableColumn="email"
                                        class="amount-div">Tournament Category</th>
                                    <th style="display: table-cell!important;" pSortableColumn="email"
                                        class="amount-div">Platform Fee Amount</th>
                                    <th style="display: table-cell!important;" pSortableColumn="email"
                                        class="amount-div">Platform Fee Rate</th>
                                    <th style="display: table-cell!important;" pSortableColumn="email"
                                        class="amount-div">Convenience Fee Amount</th>
                                    <th style="display: table-cell!important;" pSortableColumn="email"
                                        class="amount-div">Convenience Fee Rate</th>
                                    <th style="display: table-cell!important;" pSortableColumn="email"
                                        class="amount-div">Amount</th>
                                    <th style="display: table-cell!important;" pSortableColumn="email"
                                        class="amount-div">Invoices</th>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-wallet let-i="rowIndex">
                                <tr class="p-selectable-row">
                                    <td class="transactionId">
                                        <!-- {{wallet.id}} -->
                                        {{ i + 1 }}
                                    </td>
                                    <td class="transactiodescription">
                                        {{wallet.description}}
                                        <div class="mobile-date-div">
                                            {{wallet.created_at | date: 'dd MMM, yyyy'}}
                                        </div>
                                    </td>
                                    <td class="date">
                                        {{wallet.created_at | date: 'dd MMM, yyyy'}}
                                    </td>
                                    <td class="date desktop-tds-td"
                                        *ngIf="walletCashTypeFilterOption?.name !== 'TPL Coins'">
                                        <span class="mobileLable">TDS</span>
                                        <span style="color: red;" *ngIf="wallet?.tdsAmount">- {{wallet?.tdsAmount
                                            }}</span>
                                    </td>
                                    <td class="date">
                                        <span class="mobileLable">Tournament Category</span>
                                        {{wallet?.tournamentCategory}}
                                    </td>
                                    <td *ngIf="wallet.action=='ADD'" class="amount-div">
                                        <div class="wallet-amount"
                                            [ngClass]="wallet.action == 'ADD' ? 'add-amount' : ''">
                                            <span class="mobileLable">Platform Fee Amount</span>
                                            <div class="amount-div-main">
                                                <i class='bx bx-plus'></i>
                                                <span>₹{{wallet.platformFeeAmount}}</span>
                                            </div>
                                        </div>
                                    </td>
                                    <td *ngIf="wallet.action=='SUBTRACT'" class="amount-div">
                                        <div class="wallet-amount"
                                            [ngClass]="wallet.action == 'SUBTRACT' ? 'subtract-amount' : ''">
                                            <span class="mobileLable">Platform Fee Amount</span>
                                            <div class="amount-div-main">
                                                <i class='bx bx-minus'></i>
                                                <span>₹{{wallet.platformFeeAmount}}</span>
                                            </div>
                                        </div>
                                    </td>
                                    <td *ngIf="wallet.action=='ADD'" class="amount-div">
                                        <div class="wallet-amount"
                                            [ngClass]="wallet.action == 'ADD' ? 'add-amount' : ''">
                                            <span class="mobileLable">Platform Fee Rate</span>
                                            <div class="amount-div-main">
                                                <i class='bx bx-plus'></i>
                                                <span>{{ (wallet?.platformFeeType === 'flat') ? '₹' :
                                                    ''}}{{wallet.platformFeeRate}}{{ (wallet?.platformFeeType ===
                                                    'percentage') ? '%' : ''}} </span>
                                            </div>
                                        </div>
                                    </td>
                                    <td *ngIf="wallet.action=='SUBTRACT'" class="amount-div">
                                        <div class="wallet-amount"
                                            [ngClass]="wallet.action == 'SUBTRACT' ? 'subtract-amount' : ''">
                                            <span class="mobileLable">Platform Fee Rate</span>
                                            <div class="amount-div-main">
                                                <i class='bx bx-minus'></i>
                                                <span>{{ (wallet?.platformFeeType === 'flat') ? '₹' :
                                                    ''}}{{wallet.platformFeeRate}}{{ (wallet?.platformFeeType ===
                                                    'percentage') ? '%' : ''}} </span>
                                            </div>
                                        </div>
                                                                       <td *ngIf="wallet?.action=='ADD'" class="amount-div">
                                        <div class="wallet-amount"
                                            [ngClass]="wallet?.action == 'ADD' ? 'add-amount' : ''">
                                            <span class="mobileLable">Convenience Fee Amount</span>
                                            <div class="amount-div-main">
                                                <i class='bx bx-plus'></i>
                                                <span>₹{{wallet?.convenienceFeeAmount}}</span>
                                            </div>
                                        </div>
                                    </td>
                                    <td *ngIf="wallet?.action=='SUBTRACT'" class="amount-div">
                                        <div class="wallet-amount"
                                            [ngClass]="wallet?.action == 'SUBTRACT' ? 'subtract-amount' : ''">
                                            <span class="mobileLable">Convenience Fee Amount</span>
                                            <div class="amount-div-main">
                                                <i class='bx bx-minus'></i>
                                                <span>₹{{wallet?.convenienceFeeAmount}}</span>
                                            </div>
                                        </div>
                                    </td>
                                    <td *ngIf="wallet.action=='ADD'" class="amount-div">
                                        <div class="wallet-amount"
                                            [ngClass]="wallet.action == 'ADD' ? 'add-amount' : ''">
                                            <span class="mobileLable">Convenience Fee Rate</span>
                                            <div class="amount-div-main">
                                                <i class='bx bx-plus'></i>
                                                <span>{{ (wallet?.convenienceFeeType === 'flat') ? '₹' :
                                                     ''}}{{wallet.convenienceFeeRate}}{{ (wallet?.convenienceFeeType ===
                                                     'percentage') ? '%' : ''}} </span>
                                            </div>
                                        </div>
                                    </td>
                                    <td *ngIf="wallet?.action=='SUBTRACT'" class="amount-div">
                                        <div class="wallet-amount"
                                            [ngClass]="wallet?.action == 'SUBTRACT' ? 'subtract-amount' : ''">
                                            <span class="mobileLable">Convenience Fee Rate</span>
                                            <div class="amount-div-main">
                                                <i class='bx bx-minus'></i>
                                                <span>{{ (wallet?.convenienceFeeType === 'flat') ? '₹' :
                                                     ''}}{{wallet.convenienceFeeRate}}{{ (wallet?.convenienceFeeType ===
                                                     'percentage') ? '%' : ''}} </span>
                                            </div>
                                        </div>
                                    </td>
                                    <td *ngIf="wallet.action=='ADD'" class="amount-div final-amount-td">
                                        <div class="wallet-amount"
                                            [ngClass]="wallet.action == 'ADD' ? 'add-amount' : ''">
                                            <span class="mobileLable">Amount</span>
                                            <div class="amount-div-main">
                                                <i class='bx bx-plus'></i> <span>{{wallet.amount}} {{(wallet.wallettype
                                                     === 'CONTESTCASH') ? 'Contest Cash' : wallet.wallettype | lowercase
                                                     }}</span>
                                            </div>
                                            <span class="tds-div-mobile" style="color: red;" *ngIf="wallet?.tdsAmount">-
                                                {{wallet?.tdsAmount }}</span>
                                        </div>
                                    </td>
                                    <td *ngIf="wallet.action=='SUBTRACT'" class="amount-div final-amount-td">
                                        <div class="wallet-amount"
                                            [ngClass]="wallet.action == 'SUBTRACT' ? 'subtract-amount' : ''">
                                            <span class="mobileLable">Amount</span>
                                            <div class="amount-div-main">
                                                <i class='bx bx-minus'></i> <span>{{wallet?.finalPayableAmount}}
                                                {{(wallet.wallettype ===
                                                'CONTESTCASH') ? 'Contest Cash' : wallet.wallettype | lowercase }}</span>
                                            </div>
                                            <span class="tds-div-mobile" style="color: red;"
                                                *ngIf="wallet?.tdsAmount">(- {{wallet?.tdsAmount }} TDS)</span>
                                        </div>
                                    </td>
                                    <td class="pdf-td desktop-pdf-div">
                                        <i *ngIf="wallet.invoiceFile" pTooltip="Click to view Invoice PDF"
                                            class="bx bxs-file-pdf" style="color: red; font-size: 18px"
                                            (click)="downloadPdf(wallet.invoiceFile)"></i>
                                        <i *ngIf="wallet.creditInvoiceFile" pTooltip="Click to view Invoice PDF"
                                            class="bx bxs-file-pdf" style="color:green; font-size: 18px"
                                            (click)="downloadPdf(wallet.creditInvoiceFile)"></i>
                                    </td>
                                    <td class="pdf-td mobile-pdf-div">
                                        <span class="mobileLable">Invoice</span>
                                        <div class="amount-div-main" style="display: flex; gap: 8px;">
                                            <i *ngIf="wallet.invoiceFile" pTooltip="Click to view Invoice PDF"
                                                class="bx bxs-file-pdf" style="color: red; font-size: 22px"
                                                (click)="downloadPdf(wallet.invoiceFile)"></i>
                                            <i *ngIf="wallet.creditInvoiceFile" pTooltip="Click to view Invoice PDF"
                                                class="bx bxs-file-pdf" style="color: green; font-size: 22px"
                                                (click)="downloadPdf(wallet.creditInvoiceFile)"></i>
                                        </div>
                                    </td>
                                    <!-- <td >
                                        <i *ngIf="wallet.invoiceFile"   pTooltip="Click to view Invoice PDF" class="bx bxs-file-pdf" style="color: red; font-size: 18px" (click)="downloadPdf(wallet.invoiceFile)"></i>
                                        <i *ngIf="wallet.creditInvoiceFile"   pTooltip="Click to view Invoice PDF" class="bx bxs-file-pdf" style="color: red; font-size: 18px" (click)="downloadPdf(wallet.creditInvoiceFile)"></i>
                                    </td> -->
                                    <!-- <td *ngIf="wallet.coins!=0">                                    
                                    <div class="debit" *ngIf="wallet.action=='ADD'">
                                        <i class='bx bx-plus'></i> {{wallet.coins}} {{wallet.wallettype | lowercase }}<span></span>
                                    </div>
                                    <div class="credits" *ngIf="wallet.action=='SUBTRACT'">
                                        <i class='bx bx-minus'></i> {{wallet.coins}} {{wallet.wallettype | lowercase}} <span></span>
                                    </div>
                                    
                                </td>
                                <td *ngIf="wallet.cash!=0">
                                    <div class="debit" *ngIf="wallet.action=='ADD'">
                                        <i class='bx bx-plus'></i> {{wallet.cash}} {{wallet.wallettype | lowercase}}<span></span>
                                    </div>
                                    <div class="credits" *ngIf="wallet.action=='SUBTRACT'">
                                        <i class='bx bx-minus'></i> {{wallet.cash}} {{wallet.wallettype | lowercase}} <span></span>
                                    </div>
                                </td> -->
                                </tr>
                            </ng-template>

                        </p-table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<p-dialog class="add-amont-popup" [(visible)]="addCashmodal" [modal]="true" [style]="{width: '500px'}"
    [header]="paymentHeader" [breakpoints]="{'960px': '60vw', '640px': '100vw'}" [baseZIndex]="10000"
    [draggable]="false" [resizable]="false" (onHide)="cashclose()">

    <form [formGroup]="addCashOrContestCashForm" *ngIf="this.addCashOrContestCashForm">
        <div class="p-fluid p-formgrid p-grid">
            <div class="wallet-icons">
                <div class="icon"><i class="bx bx-wallet-alt"></i></div>
                <h1>Enter Amount</h1>
            </div>
            <div class="p-field p-col-12">
                <!-- <label for="amount">Amount<span class="mandatory-fields">*</span></label> -->
                <input formControlName="amount" type="text" pInputText class="form-control"
                    [ngClass]="{ 'is-invalid': submitted && f.amount.errors }" placeholder="₹ 0">
                <div *ngIf="submitted && f.amount.errors" class="invalid-feedback">
                    <div *ngIf="f.amount.errors.required">Amount is required</div>
                    <div *ngIf="!f.amount.errors.required && f.amount.errors">Only Numbers allowed</div>
                </div>
            </div>
            <div class="p-field p-col-12 msg-div">
                <p-messages severity="info">
                    <ng-template pTemplate>
                        <i class="pi pi-info-circle"></i>
                        <div class="ml-2">Please Note: For iPhone users - To make a payment using Gpay, select "Others"
                            option in the UPI menu and manually enter your UPI ID.</div>
                    </ng-template>
                </p-messages>

            </div>
        </div>
        <div class="col-md-12 text-center">

            <button type="button" (click)="onCashOrContestCashSubmit(paymentHeader)" pButton label="Add To Wallet"
                class="p-button-primery save-btn p-mr-0" style="width: auto"></button>
        </div>
    </form>
</p-dialog>
<p-dialog [(visible)]="showThankyouModal" [modal]="true" [style]="{width: '500'}" header="Thank You"
    [breakpoints]="{'960px': '60vw', '768px': 'calc(100% - 30px)'}" [baseZIndex]="10000" [draggable]="false"
    [resizable]="false" (onHide)="closeThankyou()">
    <div class="col-md-12 thankYouMSG">
        Amount added to Wallet Successfully.
    </div>
</p-dialog>

<p-dialog class="add-amont-popup" [(visible)]="addCoinmodal" [modal]="true" [style]="{width: '500px'}"
    header="Add Coins" [breakpoints]="{'960px': '60vw', '640px': '100vw'}" [baseZIndex]="10000" [draggable]="false"
    [resizable]="false" (onHide)="coinclose()">
    <!-- <form [formGroup]="addCoinForm" *ngIf="this.addCoinForm">
        <div class="p-fluid p-formgrid p-grid">
            <div class="p-field p-col-12">
                <label for="amount">Amount<span class="mandatory-fields">*</span></label>
                <input formControlName="amount" type="text" pInputText class="form-control"
                    [ngClass]="{ 'is-invalid': coinsubmitted && f1.amount.errors }">
                <div *ngIf="coinsubmitted && f1.amount.errors" class="invalid-feedback">
                    <div *ngIf="f1.amount.errors.required">Amount is required</div>
                    <div *ngIf="!f1.amount.errors.required && f1.amount.errors">Only Numbers allowed</div>
                </div>
            </div>
            <div class="p-field p-col-12">Note: 1 Cash equal to 10 Coins</div>
        </div>
        <button type="button" (click)="onCoinSubmit()" pButton icon="pi pi-check" label="Checkout"
            class="p-button-success save-btn p-mr-0" style="width: auto"></button>
    </form> -->

    <form [formGroup]="addCoinForm" *ngIf="this.addCoinForm">
        <div class="p-fluid p-formgrid p-grid">
            <div class="wallet-icons">
                <div class="icon"><i class="bx bx-wallet-alt"></i></div>
                <h1>Enter Amount</h1>
            </div>
            <div class="p-field p-col-12 mb-0">
                <!-- <label for="amount">Amount<span class="mandatory-fields">*</span></label> -->
                <input formControlName="amount" type="text" pInputText class="form-control"
                    [ngClass]="{ 'is-invalid': coinsubmitted && f1.amount.errors }" placeholder="₹ 0">
                <div *ngIf="coinsubmitted && f1.amount.errors" class="invalid-feedback">
                    <div *ngIf="f1.amount.errors.required">Amount is required</div>
                    <div *ngIf="!f1.amount.errors.required && f1.amount.errors">Only Numbers allowed</div>
                </div>
            </div>
            <div class="p-field p-col-12  text-center" style="color:#000;">Note: 1 Cash equal to 10 Coins</div>
        </div>
        <div class="col-md-12 text-center">

            <button type="button" (click)="onCoinSubmit()" pButton label="Add To Wallet"
                class="p-button-primery save-btn p-mr-0" style="width: auto"></button>
        </div>
    </form>

</p-dialog>


<p-dialog [closable]="true" [(visible)]="downloadModal" [modal]="true" [style]="{width: '416px'}"
    id="downloadModalPopup" [breakpoints]="{ '960px': '75vw', '768px': 'calc(100% - 20px)' }" [baseZIndex]="10000"
    [draggable]="false" [resizable]="false" [closable]="false" [position]="position">
    <div class="downloadbody">
        <div class="topleftbg">
            <img src="../../../../assets/images/download/topleft.png" alt="">
        </div>
        <div class="bottomrightbg">
            <img src="../../../../assets/images/download/bottomright.png" alt="">
        </div>
        <div class="bottomleftbg">
            <img src="../../../../assets/images/download/bottomleft.png" alt="">
        </div>
        <div class="download-header">
            <button (click)="downloadModal = false" class="closeBtn">
                <img src="assets/images/download/close.svg" alt="">
            </button>
        </div>
        <div class="bannerImage">
            <img src="../../../../assets/images/download/leander.png" alt="">
        </div>
        <div class="modalTitleImage">
            <img src="../../../../assets/images/download/modalTile.svg" alt="">
        </div>

        <div class="downloadList">
            <ul>
                <li>
                    <a href="https://play.google.com/store/apps/details?id=com.wiantech.tplsport&pcampaignid=web_share">
                        <img src="../../../../assets/images/download/btn1.png" alt="">
                    </a>
                </li>
                <li>
                    <a href="https://apps.apple.com/in/app/tpl-tennis-premier-league/id6461867254">
                        <img src="../../../../assets/images/download/btn2.png" alt="">
                    </a>
                </li>
            </ul>
        </div>

        <div class="orTitle">
            <div class="line"></div>
            <p>OR</p>
            <div class="line"></div>
        </div>
        <div class="scanner">
            <img src="../../../../assets/images/download/qrcode.png" alt="">
        </div>
        <div class="notesdiv">
            <p>Click the buttons above to download the <span>App!</span></p>
        </div>
    </div>
</p-dialog>